import 'unfetch/polyfill'

import VueApollo from 'vue-apollo'
import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloLink} from 'apollo-link'
import store from './store/index'
//ie下兼容origin
if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}
const customFetch = (uri, options) => {
    const id_token = store.state.oidcStore.id_token;
    return fetch(uri + '?id_token_hint=' + id_token, options);
}

// HTTP connection to the API
var httpLink = createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.KNOWLEDGE_URL,
})
var otherHttpLink=createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.TASKAPI_URL+'/graphql',
})

var manageHttpLink=createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.BUS_URL,
})

var builtinHttpLink=createHttpLink({
    uri:window.commonApi.BUS_URL,
    fetch: customFetch
})


var iamHttpLink=createHttpLink({
  uri: window.commonApi.IAM_URL,
  fetch: customFetch
})

var igaHttpLink=createHttpLink({
  uri: window.commonApi.IGA_URL,
  fetch: customFetch
})


// Cache implementation
var cache = new InMemoryCache({
	dataIdFromObject:function(o){o.id?`${o.__typename}-${o.id}`:`${o.__typename}-${o.cursor}`},
})

var middlewareLink = new ApolloLink(function(operation, forward){
const token = store.state.oidcStore.access_token;
operation.setContext({
    headers: {
      Authorization: `Bearer ${token}` || null,
    }
})
return forward(operation)
})

var defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};
var linkStr=middlewareLink.concat(httpLink);
// var linkStr=httpLink;
var apolloClient = new ApolloClient({
  link:linkStr,
  cache:cache
})

var otherLinkStr=middlewareLink.concat(otherHttpLink);
var otherApolloClient = new ApolloClient({
  link:otherLinkStr,
  cache:cache
})

var manageLinkStr=middlewareLink.concat(manageHttpLink);
var manageApolloClient = new ApolloClient({
  link:manageLinkStr,
  cache:cache
})

var builtinLinkStr=middlewareLink.concat(builtinHttpLink);
var builtinApolloClient = new ApolloClient({
    link:builtinLinkStr,
    cache:cache
})

var iamLinkStr=middlewareLink.concat(iamHttpLink);
var iamApolloClient = new ApolloClient({
    link:iamLinkStr,
    cache:cache
})

var igaLinkStr=middlewareLink.concat(igaHttpLink);
var igaApolloClient = new ApolloClient({
    link:igaLinkStr,
    cache:cache
})

window.apolloProvider = new VueApollo({
	clients: {
    	api:apolloClient,
    	other:otherApolloClient,
    	manage:manageApolloClient,
      builtin:builtinApolloClient,
      iga: igaApolloClient,
      iam: iamApolloClient
	},
	defaultClient:apolloClient
})


export default apolloProvider


// WEBPACK FOOTER //
// ./src/apolloConfig.js